import axios from 'axios'
import { authActions } from '.'
import { articleActions } from '../articles'

const setToken = token => {
	localStorage.setItem('token', token)
	axios.defaults.headers.common.Authorization = `Bearer ${token}`
}

const unsetToken = () => {
	localStorage.clear()
	axios.defaults.headers.common.Authorization = `-`
}

const removeSchemeClass = el => {
	el.className = el.className.replace(/(^|\s)scheme-\S+/g, '')

	return el
}

const hasClass = (el, cls) =>
	el.className.match(new RegExp('(\\s|^)' + cls + '(\\s|$)'))

const setScheme = (scheme = 'default') => {
	const darkMode = hasClass(
		document.getElementsByTagName('body')[0],
		'theme--dark'
	)

	let s = scheme

	if (s === 'neutral' && !darkMode) {
		s = 'dark'
	} else if (s === 'neutral' && darkMode) {
		s = 'light'
	}

	removeSchemeClass(document.body)

	document.body.classList.add(`scheme--${s}`)
}

const setTheme = (theme = 'light') => {
	document.body.classList.remove('theme--light', 'theme--dark')
	document.body.classList.add(`theme--${theme}`)

	const neutralScheme =
		hasClass(document.getElementsByTagName('body')[0], 'scheme--dark') ||
		hasClass(document.getElementsByTagName('body')[0], 'scheme--light')

	if (neutralScheme) {
		removeSchemeClass(document.body)

		document.body.classList.add(
			`scheme--${theme === 'light' ? 'dark' : 'light'}`
		)
	}
}

const initAuth = dispatch =>
	new Promise((resolve, reject) => {
		const token = localStorage.getItem('token')

		if (token) {
			axios
				.get('auth/verify-token', {
					headers: { Authorization: `Bearer ${token}` },
				})
				.then(response => {
					dispatch(authActions.putToken(response.data.token))
					dispatch(authActions.loginSuccess(response.data))
					dispatch(articleActions.getArticlesRequest(true))

					setTheme(response.data.theme)
					setScheme(response.data.team.colorScheme)

					resolve()
				})
				.catch(() => {
					dispatch(authActions.logoutRequest())

					// reject()
				})
		} else {
			resolve()
		}
	})

export { initAuth, setToken, unsetToken, setTheme, setScheme }
